import CDNImage from "@/components/CDNImage";
import Images, { Icons } from "../assets/assets";
import IndustryHeader from "../industry-details/IndustryHeader";

export default function OurTeam() {
  return (
    <section className="w-full bg-[#D9E2ED]">
      <IndustryHeader
        title={
          <>
            Our <span className="text-[#225bd4]">Team</span>
          </>
        }
        subtitle="Best People. Best Results"
        description={
          <>
            {" "}
            <span className="text-[#000000] font-[500]">
              {" "}
              We’re a team of 180+ people who are all masters of what we
              do.{" "}
            </span>
            <br></br>
            With a balanced mix of professional designers, developers, quality
            analysts, and project managers, we work as a unified team backed by
            clear vision and shared work values. At Konstant, we believe
            developing a robust digital solution requires creativity and
            discipline aligned with innovation. This synergy of technical
            excellence and collaborative energy defines how we work.
          </>
        }
        buttonText="Meet Our Team"
        buttonIcon={Icons?.chevron}
        btnMode="light"
        href={"/konstant-team"}
      />
      <div className="w-[calc(100vw-10%)] max-w-[2500px] mx-auto flex flex-col xl:flex-row gap-[30px] pb-20">
        <CDNImage
          src={Images?.our_team}
          alt="Our Team"
          width={1920}
          height={1080}
          className="w-full h-auto"
          priority={true}
        />
      </div>
    </section>
  );
}
